export default __webpack_public_path__ + "static/media/logo_white.ec35dde8.png";